// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/app.styl
// module id = 32
// module chunks = 0